"use strict";

exports.__esModule = true;
exports.ReportListAccordianViewQA = exports.ReportListAccordianItemQA = void 0;
var _react = require("@testing-library/react");
var _QA = require("../../../QA");
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ReportListAccordianViewQA = exports.ReportListAccordianViewQA = /*#__PURE__*/function (_QAComponent) {
  function ReportListAccordianViewQA() {
    return _QAComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportListAccordianViewQA, _QAComponent);
  return _createClass(ReportListAccordianViewQA, [{
    key: "items",
    get: function get() {
      return this.getAll(ReportListAccordianItemQA);
    }
  }, {
    key: "labels",
    get: function get() {
      return this.items.map(function (item) {
        return item.label.textContent;
      });
    }
  }]);
}(_QA.QAComponent);
ReportListAccordianViewQA.componentName = "ReportListAccordianView";
var ReportListAccordianItemQA = exports.ReportListAccordianItemQA = /*#__PURE__*/function (_QAComponent2) {
  function ReportListAccordianItemQA() {
    return _QAComponent2.apply(this, arguments) || this;
  }
  _inheritsLoose(ReportListAccordianItemQA, _QAComponent2);
  var _proto = ReportListAccordianItemQA.prototype;
  _proto.click = function click() {
    _react.fireEvent.click(this.element);
  };
  return _createClass(ReportListAccordianItemQA, [{
    key: "label",
    get: function get() {
      return this.getByTestId("ReportAccordianItem.Heading");
    }
  }]);
}(_QA.QAComponent);
ReportListAccordianItemQA.componentName = "AccordianItem";